import getters from '../getters';
import mutations from '../mutations';
import initialState from '../state';

describe('authentication state transitions for required 2FA setup', () => {
  it('treats setup as pending when setupRequired=true (new payload)', () => {
    const state = {
      twoFactorSetup: {
        setupRequired: true,
        required: true,
        completed: false,
      },
    };

    expect(getters.hasPendingTwoFactorSetup(state)).toBe(true);
  });

  it('treats setup as pending when required=true and completed=false (legacy-compatible payload)', () => {
    const state = {
      twoFactorSetup: {
        required: true,
        completed: false,
      },
    };

    expect(getters.hasPendingTwoFactorSetup(state)).toBe(true);
  });

  it('treats setup as not pending when required=true and completed=true', () => {
    const state = {
      twoFactorSetup: {
        required: true,
        completed: true,
        setupRequired: false,
      },
    };

    expect(getters.hasPendingTwoFactorSetup(state)).toBe(false);
  });

  it('applies fallback twoFactorSetup payload when auth_success has no twoFactorSetup', () => {
    const state = JSON.parse(JSON.stringify(initialState));

    mutations.auth_success(state, {
      data: {
        isApiKey: false,
        user: { properties: { tenantIdThemeSetting: null } },
        access: [],
        primaryScopeIds: [],
        primaryTenantIds: [],
        tenantId: 1,
      },
    });

    expect(state.twoFactorSetup).toEqual({
      required: false,
      state: 'completed',
      completed: true,
      setupRequired: false,
    });
  });

  it('clears twoFactorSetup back to completed state on logout', () => {
    const state = JSON.parse(JSON.stringify(initialState));
    state.twoFactorSetup = {
      required: true,
      state: 'verified',
      completed: false,
      setupRequired: true,
    };

    mutations.logout(state);

    expect(state.twoFactorSetup).toEqual({
      required: false,
      state: 'completed',
      completed: true,
      setupRequired: false,
    });
  });
});

describe('authentication state transitions for a transient verify failure', () => {
  it('marks the session stale without discarding the cached user', () => {
    const state = JSON.parse(JSON.stringify(initialState));
    state.status = 'success';
    state.user = { id: 'user-1', properties: {} };
    state.access = ['read'];

    mutations.verify_failed(state);

    expect(state.status).toBe('error');
    expect(state.user).toEqual({ id: 'user-1', properties: {} });
    expect(state.access).toEqual(['read']);
    expect(getters.isSessionStale(state)).toBe(true);
  });

  it('clears the stale marker once verify succeeds again', () => {
    const state = JSON.parse(JSON.stringify(initialState));
    mutations.verify_failed(state);

    mutations.auth_success(state, {
      data: {
        isApiKey: false,
        user: { id: 'user-1', properties: { tenantIdThemeSetting: null } },
        access: ['read'],
        primaryScopeIds: [],
        primaryTenantIds: [],
        tenantId: 'tenant-1',
      },
    });

    expect(state.status).toBe('success');
    expect(getters.isSessionStale(state)).toBe(false);
  });
});
